import _ClientRouter from "./client.router";
import _ConsoleRouter from "./console.router";

export const ClientRouter = _ClientRouter;
export const ConsoleRouter = _ConsoleRouter;

export default {
    ClientRouter,
    ConsoleRouter
};